import React from 'react';
import { MarkDownView } from './MarkDownView';

const termsOfUse = `
# Uslovi korišćenja

_Poslednje ažuriranje: 28. oktobar 2026._

Dobrodošli na **Puskica Kviz** platformu. Korišćenjem naše aplikacije, sajta ili usluga prihvatate ove Uslove korišćenja. Molimo vas da ih pažljivo pročitate.

---

# 1. Prihvatanje uslova

Kreiranjem naloga, pristupanjem platformi ili korišćenjem bilo kog dela usluge potvrđujete da prihvatate ove Uslove korišćenja i Politiku privatnosti.

Ukoliko se ne slažete sa bilo kojim delom ovih uslova, molimo vas da ne koristite platformu.

---

# 2. O platformi

**Puskica Kviz** je edukativna platforma namenjena učenju, proveri znanja i interaktivnom obrazovanju.

Platforma može sadržati:  
    •	Edukativne kvizove
    •	Materijale za učenje
    •	Korisničke naloge
    •	Praćenje napretka
    •	Rang liste i statistiku
    •	Interaktivni sadržaj

Zadržavamo pravo izmene, dodavanja ili uklanjanja funkcionalnosti u bilo kom trenutku.

---

# 3. Edukativni karakter i tačnost sadržaja

Sav sadržaj na platformi (lekcije, kartice, pitanja, odgovori, objašnjenja i formule) pripremamo pažljivo, ali je **informativnog i edukativnog karaktera**.

- Ne garantujemo da je sadržaj tačan, potpun, ažuran ili da odgovara bilo kom konkretnom ispitu, testu ili programu.
- Sadržaj nije zamena za zvanične udžbenike, propise, uputstva proizvođača, stručni savet lekara, pravnika, inženjera ili drugih stručnjaka.
- Pitanja i testovi su namenjeni vežbanju. Ne garantujemo prolaznost na ispitima, upisima ili proverama znanja, niti bilo koji drugi ishod učenja.
- Za važne odluke i ispite proverite informacije u zvaničnim izvorima.

Ako primetite grešku, javite nam na puskica.kviz@gmail.com i ispravićemo je. Zadržavamo pravo da bez najave menjamo, dopunjujemo ili uklanjamo sadržaj.

---

# 4. Korisnički nalozi

Prilikom kreiranja naloga saglasni ste da:

- Podaci koje unosite budu tačni i ažurni
- Čuvate sigurnost svog naloga i lozinke
- Ne delite pristupne podatke sa drugim osobama
- Snosite odgovornost za aktivnosti izvršene preko vašeg naloga

Zadržavamo pravo suspendovanja ili gašenja naloga koji krše ove uslove.

---

# 5. Dozvoljeno korišćenje

Saglasni ste da nećete:

- Koristiti platformu u nezakonite svrhe
- Pokušavati neovlašćen pristup sistemu
- Ometati rad servera, baze podataka ili funkcionalnosti platforme
- Postavljati zlonameran kod, spam ili štetan sadržaj
- Kopirati ili distribuirati sadržaj bez dozvole
- Koristiti botove ili automatizovane sisteme za zloupotrebu platforme

Svaka zloupotreba može dovesti do trajne zabrane pristupa.

---

# 6. Intelektualna svojina

Sav sadržaj platforme, uključujući ali ne ograničavajući se na:

- Tekst
- Dizajn
- Logotipe
- Grafiku
- Kvizove
- Softver
- Slike
- Edukativne materijale

predstavlja vlasništvo platforme **Puskica Kviz** ili njenih partnera i zaštićen je zakonima o intelektualnoj svojini.

Nije dozvoljeno kopiranje, distribucija ili komercijalno korišćenje sadržaja bez prethodne pisane dozvole.

---

# 7. Korisnički sadržaj

Ukoliko postavljate sadržaj na platformu, uključujući komentare, odgovore ili druge materijale:

- Zadržavate vlasništvo nad svojim sadržajem
- Dajete nam pravo da sadržaj koristimo, čuvamo i prikazujemo radi funkcionisanja platforme
- Potvrđujete da sadržaj ne krši zakon niti prava trećih lica

Zadržavamo pravo uklanjanja neprimerenog sadržaja.

---

# 8. Privatnost

Korišćenje platforme reguliše i naša Politika privatnosti, koja je sastavni deo ovih uslova.

Preduzimamo razumne mere zaštite korisničkih podataka, ali nijedan internet servis ne može garantovati potpunu bezbednost.

---

# 9. Dostupnost servisa

Trudimo se da platforma bude dostupna i funkcionalna u svakom trenutku, ali ne garantujemo neprekidan rad.

Do privremenih prekida može doći zbog:

- Održavanja sistema
- Ažuriranja
- Tehničkih problema
- Problema sa servisima trećih strana

---

# 10. Ograničenje odgovornosti

U najvećoj meri dozvoljenoj zakonom:

- Platforma se pruža „takva kakva jeste“
- Ne odgovaramo za indirektnu ili posledičnu štetu
- Ne garantujemo da će servis uvek biti bez grešaka ili potpuno siguran

Korisnici koriste platformu i sadržaj na sopstvenu odgovornost. Ne odgovaramo za odluke donete ili štetu nastalu na osnovu sadržaja platforme, niti za propuštene ispite, izgubljene prilike ili gubitak podataka.

Ništa u ovim uslovima ne isključuje odgovornost koja se po zakonu ne može isključiti.

---

# 11. Reklame i spoljni linkovi

Platforma može prikazivati oglase trećih strana (npr. Google AdSense) i sadržati linkove ka spoljnim sajtovima.

- Oglase prikazuju i njima upravljaju treće strane. Ne odgovaramo za sadržaj oglasa niti za proizvode i usluge koji se u njima reklamiraju.
- Ne kontrolišemo spoljne sajtove i ne odgovaramo za njihov sadržaj ni praksu privatnosti.
- Oglasi se prikazuju u skladu sa vašim izborom kolačića (vidi Politiku privatnosti).

---

# 12. Suspenzija i gašenje naloga

Možemo suspendovati ili trajno ugasiti nalog korisnika ukoliko:

- Krši ove Uslove korišćenja
- Zloupotrebljava platformu
- Pokušava prevaru ili neovlašćen pristup
- Ugrožava rad platforme ili druge korisnike

U ozbiljnim slučajevima nalog može biti ugašen bez prethodnog upozorenja.

---

# 13. Izmene uslova korišćenja

Zadržavamo pravo izmene ovih Uslova korišćenja u bilo kom trenutku.

Ažurirana verzija biće objavljena unutar aplikacije ili sajta, a nastavak korišćenja platforme smatraće se prihvatanjem izmena.

---

# 14. Kontakt

Za pitanja u vezi sa Uslovima korišćenja možete nas kontaktirati putem:

- Email adrese: puskica.kviz@gmail.com

Vlasnik i operator platforme: **Marčetić Zoran, Milana Rakića 16, Novi Sad, Srbija**.

---

# 15. Važeće pravo

Na ove Uslove korišćenja primenjuju se zakoni Republike Srbije, osim ukoliko lokalni propisi korisnika zahtevaju drugačije.

---

# Hvala vam

Hvala vam što koristite **Puskica Kviz** i što ste deo naše zajednice za učenje.
`;

function TermsAndConditions() {
    return (
        <div className="pb-[120px] w-full items-center flex flex-col bg-white min-h-full">
            <div className="flex flex-col items-center mt-[20px] w-full px-[10px]">
                <div className="w-full max-w-[834px] mt-[20px] pt-[20px] flex flex-col gap-[20px]  px-[10px]">
                    <MarkDownView style={{ color: 'black', textAlign: 'left', backgroundColor: 'transparent' }} source={termsOfUse}></MarkDownView>
                </div>
            </div>
        </div>
    );
}

export default TermsAndConditions;
